import { usePetitionDetailsPageFcm } from 'src/app/pages/petitionGamma/details/pageContext';

export function useCampaignActionsEnabled(): boolean {
	const { campaignActionsPageConfig } = usePetitionDetailsPageFcm();
	return Boolean(campaignActionsPageConfig?.enabled);
}
